export default __webpack_public_path__ + "static/media/ML_intradingfinance.3483cee0.png";